import { createFragmentContainer, graphql } from 'react-relay';
import Settings from './SettingsComponent';

export default createFragmentContainer(Settings, {
  viewer: graphql`
    fragment SettingsContainer_viewer on User {
      id
      first_name
      last_name
      company_name
      s_time_zone
      features {
        music_lists
      }
      payment_methods(first: 99999) @connection(key: "SettingsContainer_payment_methods") {
        edges {
          node {
            ... on SquarePaymentMethod {
              __typename
              id
              enabled
            }
            ... on CashPaymentMethod {
              __typename
              id
              enabled
              instructions
            }
            ... on CheckPaymentMethod {
              __typename
              id
              address
              enabled
              pay_to
            }
            ... on CustomPaymentMethod {
              __typename
              id
              enabled
              label
              instructions
            }
          }
        }
      }
      ...PlaylistsContainer_viewer
      ...AvailabilityCheckerContainer_viewer
    }
  `,
});



// WEBPACK FOOTER //
// ./webpack/components/App/SettingsContainer.js